<HomeNavBar ref="homeNavBarRef" />

<div class="px-2 h-100 marketplace-shell-wrap">
  <div class="container-fluid mt-2 marketplace-page-shell h-100">
    <!-- Hero -->
    <div class="card border-0 shadow-sm rounded mb-4 bg-white text-dark d-none">
      <div class="card-body">
        <div class="row g-4 align-items-center">
          <div
            class="d-flex justify-content-between align-items-start align-items-md-center flex-column flex-md-row gap-3 mb-3"
          >
            <span class="text-dark mb-3 fw-bold">
              Explore the Marketplace
            </span>

            <p class="d-none">
              Discover products from businesses in your network
            </p>

            <div class="input-group shadow-sm rounded marketplace-search-box">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-search text-muted"></i>
              </span>

              <input
                v-model="filters.search"
                type="text"
                class="form-control border-0 shadow-none"
                placeholder="Search products, businesses, shoes, bags, furniture..."
                @keyup.enter="handle_marketplace_action(1)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="position-relative mega-menu d-none"
      @mouseleave="close_mega_menu"
    >
      <div class="d-flex align-items-center bg-light">
        <!-- Left arrow -->
        <button
          class="btn btn-sm text-black tab-arrow"
          @click="scroll_departments('left')"
        >
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Scrollable container -->
        <div
          ref="departmentsContainer"
          class="d-flex overflow-auto gap-2 px-2 flex-grow-1 mb-2 mt-2"
        >
          <div
            v-for="department in departments"
            :key="department.id"
            class="department-item flex-shrink-0 fw-bold pointer"
            :class="{ 'active': String(filters.department_id) === String(department.id) }"
            @click="select_department(department.id)"
            @mouseenter="hovered_department_id = department.id"
          >
            {{ department.name }}
          </div>
        </div>

        <!-- Right arrow -->
        <button
          class="btn btn-sm text-black tab-arrow"
          @click="scroll_departments('right')"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>

      <!-- Mega Menu Dropdown -->
      <div
        v-show="hovered_department_id && get_categories_for_department(hovered_department_id).length > 0"
        class="mega-menu card bg-white border-0 border-top border-2 border-primary shadow-lg position-absolute w-100 start-0 z-3 rounded-bottom-3 top-100"
      >
        <div class="card-body p-3">
          <div class="row align-items-start px-2">
            <div
              class="col-auto pe-5 mb-4"
              v-for="category in get_categories_for_department(hovered_department_id)"
              :key="category.id"
            >
              <h6
                class="fw-bold mb-1 text-dark user-select-auto"
                role="button"
                @click="select_category(category.id); close_mega_menu()"
              >
                {{ category.name }}
              </h6>
              <ul class="list-unstyled mb-0 d-flex flex-column gap-0">
                <li
                  v-for="sub in get_subcategories_for_category(category.id)"
                  :key="sub.id"
                  class="small user-select-auto text-decoration-none text-muted dropdown-item px-2 py-1 rounded"
                  role="button"
                  @click="select_subcategory(sub.id); close_mega_menu()"
                >
                  {{ sub.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

<div
  class="d-flex justify-content-between align-items-center pe-2 gap-2 flex-wrap marketplace-header"
>

  <!-- LEFT: Suppliers -->
  <button
    class="btn btn-sm mb-0"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#suppliersOffcanvas"
    aria-controls="suppliersOffcanvas"
  >
    <i class="fas fa-bars fw-bold me-2"></i>
    See all Suppliers
  </button>

  <!-- CENTER: TITLE + TABS -->
  <div class="marketplace-toolbar-center text-center flex-grow-1 mb-4">
    <h4 class="text-dark mb-1 fw-bold marketplace-toolbar-title">
      Your Proudly SA Marketplace
    </h4>

    <div class="marketplace-tabs-shell d-inline-flex align-items-center">
      <button
        class="marketplace-tab-btn fw-semibold"
        :class="{ 'is-active': active_listing_type === 'products' }"
        type="button"
        @click="set_listing_type('products')"
      >
        Products
      </button>

      <button
        class="marketplace-tab-btn fw-semibold"
        :class="{ 'is-active': active_listing_type === 'services' }"
        type="button"
        @click="set_listing_type('services')"
      >
        Services
      </button>
    </div>
  </div>

  <!-- RIGHT: FILTERS -->
  <div class="d-flex align-items-center gap-2 flex-nowrap">
    <button
      class="btn btn-sm d-none"
      @click="fetch_wishlist_products(1)"
    >
      <i class="bi bi-heart me-1"></i> My Wishlist
    </button>

    <button
      class="btn btn-sm"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#filtersOffcanvas"
      aria-controls="filtersOffcanvas"
    >
      Filter {{ active_listing_type === 'services' ? 'Services' : 'Products' }}
      <i class="bi bi-funnel-fill ms-2"></i>
    </button>

  </div>
</div>

    <section v-if="active_listing_type !== 'services'" class="marketplace-department-panel">
      <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
        <div class="d-flex align-items-center gap-2">
          <button
            v-if="filters.category_id"
            type="button"
            class="btn btn-sm marketplace-department-back"
            @click="clear_category_filter"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <h4 class="fw-bold text-xs mb-0">
            Shop by category
          </h4>
        </div>
      </div>

      <div v-if="!filters.category_id" class="marketplace-department-scroll-shell">
        <button
          type="button"
          class="marketplace-department-arrow"
          title="Scroll categories left"
          @click="scroll_departments('left')"
        >
          <i class="bi bi-chevron-left"></i>
        </button>
        <div
          ref="marketplaceCategoryStrip"
          class="marketplace-department-strip gap-2 p-1"
        >
          <button
            v-for="category in marketplace_category_tiles"
            :key="'marketplace-category-'+category.id"
            type="button"
            class="marketplace-department-tile"
            @click="select_category(category.id)"
          >
            <span>
              <span class="marketplace-department-placeholder">
                {{ get_marketplace_tile_initials(category.name) }}
              </span>
            </span>
            <span class="marketplace-department-name">
              {{ category.name }}
            </span>
          </button>
        </div>
        <button
          type="button"
          class="marketplace-department-arrow"
          title="Scroll categories right"
          @click="scroll_departments('right')"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>

      <div v-else-if="marketplace_subcategory_tiles.length" class="marketplace-department-scroll-shell">
        <button
          type="button"
          class="marketplace-department-arrow"
          title="Scroll subcategories left"
          @click="scroll_departments('left')"
        >
          <i class="bi bi-chevron-left"></i>
        </button>
        <div
          ref="marketplaceCategoryStrip"
          class="marketplace-department-strip"
        >
          <button
            v-for="subcategory in marketplace_subcategory_tiles"
            :key="'marketplace-subcategory-'+subcategory.id"
            type="button"
            class="marketplace-department-tile"
            :class="{ 'is-active': String(filters.subcategory_id) === String(subcategory.id) }"
            @click="select_subcategory(subcategory.id)"
          >
            <span>
              <span class="marketplace-department-placeholder">
                {{ get_marketplace_tile_initials(subcategory.name) }}
              </span>
            </span>
            <span class="marketplace-department-name">
              {{ subcategory.name }}
            </span>
          </button>
        </div>
        <button
          type="button"
          class="marketplace-department-arrow"
          title="Scroll subcategories right"
          @click="scroll_departments('right')"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>

      <div v-else class="marketplace-department-empty">
        No subcategories available for {{ selected_category_name }}.
      </div>
    </section>

    <div class="offcanvas offcanvas-start mt-4"
      tabindex="-1"
      id="suppliersOffcanvas"
      aria-labelledby="suppliersOffcanvasLabel"
    >
      <div class="offcanvas-header mt-5">
        <h5 class="offcanvas-title" id="suppliersOffcanvasLabel">Suppliers</h5>
        <button
  type="button"
  class="btn btn-sm text-primary p-0 border-0 bg-transparent shadow-none"
  data-bs-dismiss="offcanvas"
  aria-label="Close"
>
  <i class="fas fa-times fs-4"></i>
</button>
      </div>
      <div class="offcanvas-body">
        <div v-if="visible_suppliers.length" class="row g-1">
          <div
            v-for="supplier in visible_suppliers"
            :key="supplier.id"
            class="col-6">
            <button
              type="button"
              class="btn border w-100 d-flex flex-column align-items-center py-3 supplier-card"
              @click="view_profile(supplier)"
              data-bs-dismiss="offcanvas"
            >
              <!-- Logo -->
              <img
                v-if="supplier.logo_url"
                :src="supplier.logo_url"
                :alt="supplier.company_name"
                class="rounded-circle border mb-2 supplier-logo"
              />
              <div
                v-else
                class="rounded-circle border d-flex align-items-center justify-content-center fw-bold text-primary mb-2 supplier-logo"
              >
                {{ get_supplier_initials(supplier.company_name) }}
              </div>

              <!-- Supplier Name -->
            <div class="text-center">
            <span class="fw-semibold d-block w-100 marketplace-supplier-name">
              {{ supplier.company_name }}
            </span>
          </div>
            </button>
          </div>
        </div>

        <div v-else class="text-muted text-center py-4">
          No suppliers available for the current results yet.
        </div>
      </div>
    </div>
    <div
      class="offcanvas offcanvas-end mt-4"
      tabindex="-1"
      id="filtersOffcanvas"
      aria-labelledby="filtersOffcanvasLabel"
    >
      <div
        class="offcanvas-header mt-5 d-flex align-items-center justify-content-start gap-3"
      >
        <button
  type="button"
  class="btn btn-sm text-primary p-0 border-0 bg-transparent shadow-none"
  data-bs-dismiss="offcanvas"
  aria-label="Close"
>
  <i class="fas fa-times fs-4"></i>
</button>
      <h5 class="offcanvas-title mb-0" id="filtersOffcanvasLabel">
      Filter {{ active_listing_type === 'services' ? 'Services' : 'Products' }}
    </h5>
      </div>
      <div class="offcanvas-body">

        <div class="input-group rounded bg-light shadow-sm search-box w-100 mb-3">
            <span class="input-group-text bg-light border-0">
              <i class="bi bi-search text-muted"></i>
            </span>

            <input
              v-model="filters.search"
              type="text"
              class="form-control bg-light border-0 shadow-none pe-2"
              :placeholder="active_listing_type === 'services' ? 'Search services...' : 'Search products...'"
              @keyup.enter="handle_marketplace_action(1)"
            />
          </div>
        <!-- Department filter -->
        <div v-if="active_listing_type !== 'services'" class="mb-3">
          <label class="form-label fw-semibold">Department</label>
          <select
            class="form-select"
            v-model="filters.department_id"
            @change="on_department_change"
          >
            <option value="">All Departments</option>
            <option
              v-for="department in departments"
              :key="department.id"
              :value="department.id"
            >
              {{ department.name }}
            </option>
          </select>
        </div>

        <!-- Category filter -->
        <div v-if="active_listing_type !== 'services'"  class="mb-3">
          <label class="form-label fw-semibold">Category</label>
          <select
            class="form-select"
            v-model="filters.category_id"
            @change="on_category_change"
          >
            <option value="">All Categories</option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>

        <!-- Subcategory filter -->
        <div v-if="active_listing_type !== 'services'"  class="mb-3">
          <label class="form-label fw-semibold">Subcategory</label>
          <select
            class="form-select"
            v-model="filters.subcategory_id"
            @change="on_subcategory_change"
          >
            <option value="">All Subcategories</option>
            <option
              v-for="subcategory in subcategories"
              :key="subcategory.id"
              :value="subcategory.id"
            >
              {{ subcategory.name }}
            </option>
          </select>
        </div>

        <!-- Price filter -->
        <div v-if="active_listing_type !== 'services'"  class="mb-4">
          <label class="form-label fw-semibold">Price Range</label>
          <select class="form-select rounded" v-model="filters.price_range">
            <option value="">Any Price</option>
            <option value="0-1000">Under R1,000</option>
            <option value="1000-5000">R1,000 - R5,000</option>
            <option value="5000-20000">R5,000 - R20,000</option>
            <option value="20000-plus">Over R20,000</option>
          </select>
        </div>

        <!-- Buttons -->
        <div v-if="active_listing_type !== 'services'"  class="d-grid gap-2">
          <button class="btn btn-primary rounded" @click="on_filter_change">
            Apply Filters
          </button>
          <button
            class="btn btn-outline-secondary rounded"
            @click="clear_filters"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
    <div class="row g-4 marketplace-listings-row pb-extra">
      <!-- Sidebar -->

      <!-- Main content -->
      <div class="col-12 px-2 px-md-3 marketplace-products-wrap">
        <!-- Product grid -->
        <div
          v-if="is_loading"
          class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
          role="status"
          aria-live="polite"
        >
          <div class="marketplace-loader-card">
            <div class="marketplace-loader-orbit">
              <span
                class="marketplace-loader-ring marketplace-loader-ring-primary"
              ></span>
              <span
                class="marketplace-loader-ring marketplace-loader-ring-secondary"
              ></span>
              <span
                class="marketplace-loader-core d-flex align-items-center justify-content-center"
              >
                <i class="bi bi-bag-heart-fill"></i>
              </span>
              <span
                class="marketplace-loader-dot marketplace-loader-dot-one"
              ></span>
              <span
                class="marketplace-loader-dot marketplace-loader-dot-two"
              ></span>
            </div>
            <p class="marketplace-loader-title mb-1">Loading marketplace</p>
            <p class="marketplace-loader-copy mb-0">
              We are bringing products and services into view.
            </p>
            <span class="visually-hidden">Loading products...</span>
          </div>
        </div>

        <div
          v-else-if="displayed_products.length > 0"
          class="row g-1 marketplace-products-grid">
          <div
            class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2"
            v-for="product in displayed_products"
            :key="product.id"
          >
            <div
              class="marketplace-product-card h-100 d-flex flex-column"
              @click.stop="view_product_details(product)"
            >
              <div class="position-relative marketplace-card-media">
                <div class="ratio ratio-1x1 rounded">
                  <img
                    :src="product.images?.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
                    :alt="product.name"
                    class="marketplace-card-image"
                  />
                </div>

                <!-- Wishlist toggle button -->
                <div class="position-absolute top-0 end-0 m-2">
                  <div class="d-flex gap-2">
                    <!-- Wishlist -->
                    <button
                      class="btn btn-sm btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center marketplace-card-icon-btn d-none"
                      @click.stop="toggle_wishlist(product)"
                      :title="product.is_wishlisted ? 'Remove from wishlist' : 'Add to wishlist'"
                    >
                      <i
                        class="bi"
                        :class="product.is_wishlisted ? 'bi-heart-fill text-danger' : 'bi-heart text-primary'"
                      ></i>
                    </button>

                    <!-- Cart -->
                    <button
                      v-if="product.product_type?.name !== 'service'"
                      class="btn btn-sm btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center marketplace-card-icon-btn"
                      @click.stop="add_product_to_cart(product)"
                      title="Add to cart"
                    >
                      <i class="bi bi-cart-plus text-primary"></i>
                    </button>
                    <i v-else
                      class="bi text-primary  rounded-circle shadow-sm d-flex align-items-center justify-content-center marketplace-card-icon-btn bg-light" 
                      :class="product.service_details?.type_name === 'drop_in' ? 'bi-shop' : 'bi bi-truck'"
                      :title="product.service_details?.type_name === 'drop_in' ? 'Drop-In Service' : 'Field Service'">
                    </i>
                  </div>
                </div>
              </div>

              <div
                class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1"
              >
                
                <div class="flex-grow-1">
                  <div
                    class="d-flex align-items-center justify-content-between gap-2 mb-2 d-none"
                  >
                    <span class="marketplace-card-pill">
                      {{ product.product_type?.name === 'service' ? 'Service' : 'Product' }}
                    </span>
                  </div>
                  <p class="marketplace-card-name mb-1">{{ product.name }}</p>
                  <p class="text-xs text-muted mb-0" v-if="product.product_type?.name.toLowerCase() !== 'service'">
                    {{ get_company_name(product) }}
                  </p>
                  <p v-if="product?.service_details?.location" class="text-xs text-muted mb-0 mt-1">
                    <i class="bi bi-geo-alt-fill text-primary"></i>
                    <span><strong> Location:</strong> {{ product?.service_details?.location }}</span>
                  </p>
                </div>

                <div
                  class="d-flex justify-content-between align-items-end gap-2 mt-3 marketplace-card-footer"
                >
                  <div class="marketplace-card-price-wrap">
                    <span class="marketplace-card-price">
                      R{{ format_price(display_price(product)) }}
                    </span>
                  </div>
                  <button
                    class="btn btn-primary btn-sm rounded"
                    @click.stop="view_product_details(product)"
                  >
                    {{ product.product_type?.name === 'service' ? 'View Service' : 'View Product' }}
                  </button>
                </div>
                
              </div>
            </div>
          </div>
        </div>

        <!-- Empty -->
        <div v-else class="">
          <div class="text-center py-5">
            <i class="bi bi-search display-4 text-muted"></i>
            <h5 class="fw-bold mt-3">
              No {{ active_listing_type === 'services' ? 'services' : 'products'
              }} found
            </h5>
            <p class="text-muted mb-3">Try adjusting your search or filters.</p>
          </div>
        </div>

        <!-- Infinite scroll sentinel -->
        <div
          v-if="current_pagination.has_more && !is_loading"
          ref="infiniteScrollSentinel"
          class="mt-4 infinite-scroll-sentinel"
        ></div>

        <!-- Loading indicator for infinite scroll -->
        <div
          v-if="infinite_scroll_loading"
          class="d-flex justify-content-center align-items-center mt-4 py-4"
        >
          <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
            <span class="visually-hidden">Loading more products...</span>
          </div>
          <span class="text-muted small">Loading more products...</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Product Detail Modal -->
<teleport to="body">
  <div
    class="modal fade"
    id="product_details_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog"
    >
      <div
        class="modal-content rounded overflow-hidden border-0 shadow-lg marketplace-modal-surface"
        v-if="selected_product"
      >
        <!-- Modal Header -->
        <div
            class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
            <button
              type="button"
              class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn"
              data-bs-dismiss="modal"
              aria-label="Close">
              <i class="fas fa-times fs-6"></i>
            </button>
          </div>

        <!-- Modal Body (Everything is scrollable inside) -->
        <div class="modal-body p-2 ">
          <div class="row g-0">
            <!-- Image Carousel -->
            <div class="col-lg-5 p-md-2 bg-transparent">
              <div class="ratio ratio-1x1 rounded bg-light">
                  <div>
                  <img
                    :src="selected_product?.images?.[active_image_index]?.image_url || require('@/assets/images/image_placeholder.jpg')"
                    class="w-100 h-100 marketplace-card-image"
                    :alt="selected_product?.name + ' image'"
                  />
                </div>
                <!-- Wishlist Button overlay on Image -->
                <button
                  type="button"
                  class="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow d-flex align-items-center justify-content-center z-index-10 d-none"
                  width="36"
                  height="36"
                  @click.stop="toggle_wishlist(selected_product)"
                  :title="selected_product.is_wishlisted ? 'Remove from wishlist' : 'Add to wishlist'"
                >
                  <i
                    class="bi fs-6"
                    :class="selected_product.is_wishlisted ? 'bi-heart-fill text-danger' : 'bi-heart text-primary'"
                  ></i>
                </button>
              <div v-if="selected_product?.images?.length > 1">
                <button
                  type="button"
                  class="btn bg-transparent position-absolute top-50 start-0 translate-middle-y ms-2 shadow-sm"
                  @click="go_to_previous_image"
                >
                  <i class="bi bi-chevron-left"></i>
                </button>

                <button
                  type="button"
                  class="btn bg-transparent position-absolute top-50 end-0 translate-middle-y me-2 shadow-sm"
                  @click="go_to_next_image"
                >
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
              </div>

              <!-- Thumbnails -->
            <div v-if="selected_product?.images?.length > 1"
                class="d-flex gap-1 p-3 border-rounded overflow-auto">

              <img
                v-for="(image, index) in selected_product.images || []"
                :key=" image.id || index"
                :src="image?.image_url"
                class="btn p-0 border rounded-3 overflow-hidden ad-image pointer"
                :class="active_image_index === index ? 'border-primary' : 'border-transparent'"
                :alt="'Thumb ' + (index + 1)"
                @click="go_to_image(index)"
              />

            </div>
            </div>

            <!-- Content Area -->
            <div class="col-lg-7 p-md-1 bg-light ">
              <!-- Title + Price -->
              <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
                <div>
                  <div class="d-flex flex-wrap gap-2 mb-2">
                  </div>
                  <h4 class="fw-bold text-dark mb-1">
                    {{ selected_product.name }}
                  </h4>
                  <span
                    class="text-xs text-muted d-block marketplace-modal-supplier"
                  >
                    Supplied by
                    <span class="fw-semibold text-primary fw-bold pointer"
                @click="view_profile(selected_product.base_profile)"
                      >{{ get_company_name(selected_product) }}</span
                    >
                  </span>
                <div class="mt-2" v-if="selected_product?.attributes?.length">
                  <div
                    v-for="group in group_attributes(selected_product.attributes)"
                    :key="group.key"
                    class="attribute-row flex-wrap mb-3 d-block"
                  >

                    <!-- LABEL + ERROR -->
                    <div class="attribute-label mb-1 d-flex align-items-center gap-2">

                      <span class="attribute-label">
                        {{ group.label || group.key }}
                      </span>

                      <span
                        v-if="attribute_errors[group.key]"
                        class="attribute-error text-danger"
                      >
                        {{ attribute_errors[group.key] }}
                      </span>

                    </div>

                    <!-- OPTIONS -->
                    <div class="d-flex flex-wrap gap-2 pointer">

                      <div
                        v-for="(attr, i) in group.values"
                        :key="i"
                        class="attribute-box d-flex align-items-center justify-content-center"
                        :class="{
                          active: selected_attributes[group.key] === attr.id
                        }"
                        @click="select_attribute(group.key, attr)"
                      >
                        {{ attr.value }}
                      </div>

                    </div>

                  </div>
                  </div>
                </div>
              </div>

              <div class="marketplace-modal-meta mb-3">
                <div class="marketplace-modal-meta-row">
                  <span class="marketplace-modal-meta-label">QTY:</span>
                  <div class="marketplace-qty-control ms-2">
                    <button type="button" @click="decrease_modal_quantity">
                      -
                    </button>
                    <span>{{ selected_quantity }}</span>
                    <button type="button" @click="increase_modal_quantity">
                      +
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-start flex-column mb-2">
                <span
                  class="flex-shrink-0 marketplace-modal-price"
                  :class="selected_product.product_type?.name === 'service' ? 'text-primary' : ''"
                >
                  R {{ format_price(selected_product_total_price) }}
                </span>
              </div>

              <div class="marketplace-modal-actions mb-4">
                <button
                  class="btn btn-sm text-dark marketplace-modal-btn"
                  @click="add_selected_product_to_cart"
                >
                  Add to Cart
                </button>
                <button
                  class="btn btn-sm rounded btn-primary"
                  @click="buy_selected_product"
                >
                  Buy Now
                </button>
              </div>

              <div class="marketplace-modal-meta-row">
                <span class="marketplace-modal-meta-label"
                  >Delivery takes 3-5 business days</span
                >
              </div>
              <!-- Description -->
              <p
                v-if="selected_product?.description"
                class="text-muted text-xs mb-4 marketplace-modal-description mt-3"
              >
                {{ selected_product?.description }}
              </p>
              <div class="marketplace-payment-row d-none">
                <span class="marketplace-payment-logo-wrap">
                  <img
                    class="marketplace-payment-logo"
                    :src="require('@/assets/images/payment_icons/visa.png')"
                    alt="Visa"
                  />
                </span>
                <span class="marketplace-payment-logo-wrap">
                  <img
                    class="marketplace-payment-logo"
                    :src="require('@/assets/images/payment_icons/mastercard.png')"
                    alt="Mastercard"
                  />
                </span>
                <span class="marketplace-payment-logo-wrap">
                  <img
                    class="marketplace-payment-logo"
                    :src="require('@/assets/images/payment_icons/google_pay.png')"
                    alt="Google Pay"
                  />
                </span>
                <span class="marketplace-payment-logo-wrap">
                  <img
                    class="marketplace-payment-logo"
                    :src="require('@/assets/images/payment_icons/apple_pay.png')"
                    alt="Apple Pay"
                  />
                </span>
                <span class="marketplace-payment-logo-wrap">
                  <img
                    class="marketplace-payment-logo"
                    :src="require('@/assets/images/payment_icons/capitec_pay.png')"
                    alt="Capitec Pay"
                  />
                </span>
              </div>

              <hr class="my-3 d-none" />

              <!-- Rate this product (visitors only, not yet rated) -->
              <div
                v-if="!selected_product?.can_review"
                class="alert d-flex align-items-center gap-2 py-2 small rounded mb-4 d-none"
              >
                <i class="bi bi-check-circle-fill"></i>
                You can only review
                <span v-if="selected_product.product_type?.name === 'service'"
                  >services after they have been completed</span
                >
                <span v-else>products after they have been delivered</span>
              </div>
              <div
                v-else-if="!selected_product?.user_has_rated_product && selected_product?.can_review && !isOwner"
                class="card border bg-light rounded-5 shadow p-3 mb-4 d-none"
              >
                <h6
                  class="fw-bold text-dark mb-1 d-flex align-items-center gap-2"
                >
                  <i class="bi bi-pencil-square text-primary"></i>
                  Rate this {{ selected_product.product_type?.name }}
                </h6>
                <p class="text-muted small mb-2">
                  How was your experience with this {{
                  selected_product.product_type?.name }}?
                </p>

                <div class="d-flex align-items-center gap-1 mb-1">
                  <i
                    v-for="n in 5"
                    :key="n"
                    class="pointer"
                    :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-warning' : 'bi bi-star text-secondary'"
                    @mouseenter="hover_rating = n"
                    @mouseleave="hover_rating = 0"
                    @click="new_rating = n"
                  ></i>
                </div>

                <p class="text-muted small mb-2">{{ rating_level }}</p>

                <textarea
                  v-model="product_review_text"
                  class="form-control form-control-sm mb-3 rounded"
                  rows="4"
                  placeholder="Share your thoughts — quality, value, reliability..."
                ></textarea>

                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-primary btn-sm fw-semibold rounded"
                    :disabled="!new_rating || !product_review_text.trim()"
                    @click="submit_product_review(selected_product)"
                  >
                    Submit Review
                  </button>
                </div>
              </div>

              <!-- Success state after rating -->
              <div
                v-if="user_has_rated_product"
                class="alert alert-success d-flex align-items-center gap-2 py-2 small rounded-4 mb-4 d-none"
              >
                <i class="bi bi-check-circle-fill"></i>
                Your review has been submitted. Thank you!
              </div>

              <!-- All Reviews -->
              <div class="d-none">
                <h6 class="fw-bold text-dark mb-3">
                  All Reviews
                  <span class="text-muted fw-normal"
                    >({{ product_reviews.length }})</span
                  >
                </h6>

                <div
                  v-if="product_reviews.length === 0"
                  class="text-center py-4 text-muted text-xs"
                >
                  No reviews yet. Be the first!
                </div>

                <div v-else class="d-flex flex-column gap-2">
                  <div
                    v-for="(review, index) in product_reviews"
                    :key="index"
                    class="card border bg-light rounded p-3"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center mb-1"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <span
                          v-if="review?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                          class="fw-bold text-dark text-xs"
                        >
                          {{ review?.base_profile?.user?.first_name }} {{
                          review?.base_profile?.user?.last_name }}
                        </span>
                        <span v-else class="fw-bold text-dark text-xs">
                          {{ review?.base_profile?.user?.first_name }} {{
                          review?.base_profile?.user?.last_name || 'User Name'
                          }}
                        </span>
                        <span
                          v-if="String(review?.base_profile?.user?.id) === String(user_details?.user_id)"
                          class="badge rounded-pill text-primary bg-primary-subtle border border-primary-subtle"
                          >You</span
                        >
                      </div>
                      <span class="text-muted text-xxs"
                        >{{ format_date(review.created_at) }}</span
                      >
                    </div>
                    <div class="d-flex gap-1 mb-2">
                      <i
                        v-for="star in 5"
                        :key="star"
                        :class="star <= review.rating ? 'bi bi-star-fill text-warning' : 'bi bi-star text-muted'"
                        class="text-xs"
                      >
                      </i>
                    </div>
                    <p class="text-muted text-xs mb-0 fst-italic">
                      "{{ review.review }}"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
<teleport to="body">
  <div class="modal fade" id="service_request_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl ">
      <div class="modal-content shadow border-0 overflow-hidden rounded">
        <div
            class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
            <button
              type="button"
              class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn"
              data-bs-dismiss="modal"
              aria-label="Close">
              <i class="fas fa-times fs-6"></i>
            </button>
          </div>
       

        <div class="modal-body bg-light">
          <div class="row g-0">
            <div class="col-lg-5  p-md-2 bg-transparent">
              <div class="ratio ratio-1x1 rounded bg-light">
                  <div>
                    <img :src="service_request?.images?.[active_image_index]?.image_url || require('@/assets/images/image_placeholder.jpg')"
                      class="w-100 h-100 marketplace-card-image"
                      :alt="service_request?.name + ' image ' + (index + 1)">

                  </div>
                  <div v-if="service_request?.images?.length > 1">
                    <button
                    type="button"
                    class="btn bg-transparent position-absolute top-50 start-0 translate-middle-y ms-2 shadow-sm"
                    @click="go_to_previous_image"
                  >
                    <i class="bi bi-chevron-left"></i>
                  </button>
                  <button
                    type="button"
                    class="btn bg-transparent position-absolute top-50 end-0 translate-middle-y me-2 shadow-sm"
                    @click="go_to_next_image"
                  >
                    <i class="bi bi-chevron-right"></i>
                  </button>
                  </div>
              </div>
              <h4 class="fw-bold text-dark mb-1 mt-3">{{ service_request?.name }}</h4>
              <p class="text-muted mb-2">Offered by <span class="fw-bold text-primary">{{ get_company_name(service_request) }}</span></p>
              <div class="mb-3">
            <div v-if="service_request?.service_details?.type_name === 'drop_in'" class="d-flex align-items-center gap-2 text-dark small">
              <i class="bi bi-geo-alt-fill text-primary"></i>
              <span><strong>Location:</strong> {{ service_request?.service_details.location }}</span>
            </div>

            <div v-else-if="service_request?.service_details?.type_name === 'on_site'" class="d-flex align-items-center gap-2 text-muted text-xs italic">
              <i class="bi bi-info-circle-fill text-info"></i>
              <span>Please provide the address where the service should be conducted in the form.</span>
            </div>
          </div>
              <h5 class="fw-bold text-dark mb-3 text-sm">R{{ format_price(display_price(service_request)) }}</h5>
  
              <div class="text-muted text-xs lh-lg quill-content" v-html="service_request?.description"></div>
              <div v-if="service_request?.images?.length > 1"
                class="d-flex gap-1 border-rounded overflow-auto">
                <img
                  v-for="(image, index) in service_request.images"
                  :key="image.id || index"
                  :src="image.image_url"
                  class="btn p-0 border rounded-3 overflow-hidden ad-image pointer"
                  :class="active_image_index === index ? 'border-primary' : 'border-transparent'"
                  :alt="'Thumb ' + (index + 1)"
                  @click="go_to_image(index)"/>
              </div>
            </div>

            <div class="col-lg-7 p-md-1 bg-light ">
              <div class="card border-2 border-primary bg-white rounded shadow-sm p-3  d-flex flex-column py-5">
                
                <h6 class="text-center fw-bold text-dark mb-4">Request a Session</h6>

                <div class="mb-3 ">
                  <label class="small fw-bold text-dark mb-2 d-block ms-1">Preferred Date</label>
                  <input type="datetime-local" class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.date" :min="min_date" step="60"
                    @input="sync_service_request_field('date')"
                    @change="sync_service_request_field('date')">
                  <p v-if="errors.service_date" class="text-danger text-xxs mt-1 mb-0">{{ errors.service_date }}</p>
                </div>

                <div class="row mb-3 g-3">
                  <div class="col-md-6">
                    <label class="small fw-bold text-dark mb-2 d-block ms-1">Email Address</label>
                    <input type="email" class="form-control border-1 border-primary rounded bg-light" 
                      v-model="service_request.email" placeholder="your@email.com"
                      autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false"
                      @input="sync_service_request_field('email')">
                    <p v-if="errors.email" class="text-danger text-xxs mt-1 mb-0">{{ errors.email }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="small fw-bold text-dark mb-2 d-block ms-1">Phone Number</label>
                    <input type="tel" class="form-control border-1 border-primary rounded bg-light" 
                      v-model="service_request.contact_number" placeholder="012 345 6789"
                      autocomplete="tel" inputmode="tel" @input="sync_service_request_field('contact_number')">
                    <p v-if="errors.contact_number" class="text-danger text-xxs mt-1 mb-0">{{ errors.contact_number }}</p>
                  </div>
                </div>
                <div v-if="service_request?.service_details?.type_name === 'on_site'" class="mb-3">
                  <label class="small fw-bold text-dark mb-2 d-block ms-1">Street Address</label>
                    <input type="text" ref="marketplaceLocationInput" class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.location" placeholder="Start typing your physical address..."
                    @input="sync_service_request_field('location')">
                  <p v-if="errors.location" class="text-danger text-xxs mt-1 mb-0">{{ errors.location }}</p>
                </div>

                <div class="mb-3" >
                  <label class="small fw-bold text-dark  d-block ms-1">Additional Notes</label>
                  <textarea class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.message" rows="5" 
                    placeholder="Tell us more about your requirements..."></textarea>
                </div>

                <button type="button" class="btn btn-primary w-100 fw-bold py-2 rounded shadow-sm" 
                  @click="submit_service_request">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                  Book Service
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
